import { Preview } from '../../../pages/Studio/Preview';
import { DisplayCanvas } from '../../../components/widgets/DisplayCanvas';
import { Label } from '@radix-ui/react-context-menu';

type DisplayInfo = {
  displayId: number;
  width: number;
  height: number;
  x: number;
  y: number;
};

type BeaconDisplayProps = {
  displays: DisplayInfo[];
  selectedDisplayId: number;
  isLive: boolean;
  elapsedTime: number;
  isDisplaySelected: boolean;
  onDisplayClick: (index: number) => void;
  showTitle?: boolean;
  height?: 'auto' | 'lg';
};

const formatElapsedTime = (ms: number) => {
  const totalSeconds = Math.floor((ms ?? 1) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours}h ${minutes}m ${seconds}s`;
};

export const BeaconDisplay = ({
  displays,
  selectedDisplayId,
  isLive,
  elapsedTime,
  isDisplaySelected,
  onDisplayClick,
  showTitle = true,
  height = 'auto',
}: BeaconDisplayProps) => {
  return (
    <div className='theme-midnight:bg-slate-800 bg-darker border-primary overflow-hidden rounded-lg border-2'>
      <div className='flex w-full flex-col'>
        <div className='relative w-full'>
          <div className='aspect-video w-full overflow-hidden bg-black'>
            <Preview />
          </div>
          {isLive && (
            <span className='absolute left-4 top-4 flex items-center gap-x-2 text-red-600'>
              <Label className='text-md font-semibold tabular-nums'>{formatElapsedTime(elapsedTime)}</Label>
            </span>
          )}
        </div>
        {isDisplaySelected && displays.length > 1 && (
          <div className='relative flex items-center justify-center border-t border-slate-700 bg-slate-950'>
            <DisplayCanvas displays={displays.map(d => ({
              displayId: d.displayId,
              properties: {
                bounds: { x: d.x, y: d.y, width: d.width, height: d.height },
                desktopCoordinates: { x: d.x, y: d.y, width: d.width, height: d.height },
                displayName: `Display ${d.displayId}`,
                isPrimary: false,
                isSelected: false as const,
                rotationDegrees: 0,
                virtualBounds: { x: d.x, y: d.y, width: d.width, height: d.height },
              },
            }))} onDisplayClick={onDisplayClick} selectedId={selectedDisplayId} showTitle={showTitle} />
          </div>
        )}
      </div>
    </div>
  );
};
